import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Button, Divider, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteModuleVersion, updateModuleVersion } from "../../../../actions/fgModuleActions";
import CustomerPriceDialog from "./CustomerPriceDialog";
import FeatureAssignmentPanel from "./FeatureAssignmentPanel";

const formatPrice = (price) => {
    if (typeof price !== "number") return "";
    return price.toLocaleString("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

const VersionDetailPanel = ({ version, inheritedFeatures }) => {
    const dispatch = useDispatch();
    const [isEditing, setIsEditing] = useState(false);
    const [price, setPrice] = useState(version?.monthlyPrice.toString() || "");
    const [description, setDescription] = useState(version?.description || "");
    const { feedback } = useSelector((state) => state.fgModules);
    const [isPriceDialogOpen, setPriceDialogOpen] = useState(false);
    const [errors, setErrors] = useState({});

    const handlePriceChange = (e) => {
        const value = e.target.value;
        const regex = /^\d*(\.\d{0,2})?$/;
        if (regex.test(value)) {
            setPrice(value);
        }
    };

    const handleSave = () => {
        if (!price) {
            setErrors({ price: "Preis ist ein Pflichtfeld." });
            return;
        }
        if (!description) {
            setErrors({ description: "Beschreibung ist ein Pflichtfeld." });
            return;
        }
        if (version) {
            dispatch(
                updateModuleVersion({
                    moduleVersionId: version.id,
                    monthlyPrice: Number(price),
                    description: description,
                })
            );
            setIsEditing(false);
        }
    };

    const handleDelete = () => {
        if (version && window.confirm(`Möchten Sie die Version "${version.version}" wirklich löschen?`)) {
            dispatch(deleteModuleVersion(version.id));
        }
    };

    if (!version) {
        return <Typography>Diese Version wurde noch nicht angelegt.</Typography>;
    }

    return (
        <>
            <Box>
                {isEditing ? (
                    <Stack spacing={2}>
                        <TextField
                            label="Monatlicher Preis (€)"
                            value={price}
                            onChange={handlePriceChange}
                            type="number"
                            fullWidth
                            required
                            error={!!errors.price}
                            helperText={errors.price}
                        />
                        <TextField
                            label="Beschreibung"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            multiline
                            rows={4}
                            fullWidth
                            required
                            error={!!errors.description}
                            helperText={errors.description}
                        />
                        <Stack direction="row" spacing={1}>
                            <Button variant="contained" onClick={handleSave}>
                                Speichern
                            </Button>
                            <Button onClick={() => setIsEditing(false)}>Abbrechen</Button>
                        </Stack>
                    </Stack>
                ) : (
                    <Stack spacing={2}>
                        <Typography>
                            <strong>Preis:</strong> {formatPrice(version.monthlyPrice)} €
                        </Typography>
                        <Typography>
                            <strong>Beschreibung:</strong> {version.description || "-"}
                        </Typography>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Button variant="outlined" onClick={() => setIsEditing(true)}>
                                Modulversion bearbeiten
                            </Button>
                            <Button variant="outlined" onClick={() => setPriceDialogOpen(true)}>
                                Lizenzpreise verwalten
                            </Button>
                            <Button
                                startIcon={<DeleteIcon />}
                                onClick={handleDelete}
                                color="error"
                                style={{ marginLeft: "auto" }}
                            >
                                Modulversion löschen
                            </Button>
                        </Stack>
                    </Stack>
                )}
                <Divider sx={{ my: 3 }} />
                <FeatureAssignmentPanel version={version} inheritedFeatures={inheritedFeatures} />
            </Box>
            <CustomerPriceDialog open={isPriceDialogOpen} onClose={() => setPriceDialogOpen(false)} version={version} />
        </>
    );
};

export default VersionDetailPanel;
